import script from "./MessageReactionPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageReactionPicker.vue?vue&type=script&setup=true&lang=ts"

import "./MessageReactionPicker.vue?vue&type=style&index=0&id=5af7bc55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af7bc55"]])

export default __exports__